import { URL_PATTERN } from '../components/constants/UrlPattern'

export default class ChamomileUrl {
  readonly url: string
  readonly protocol: string
  readonly domain: string
  readonly path: string
  readonly query: string
  readonly hash: string

  constructor(url: string) {
    this.url = url.trim()
    const matched = this.url.match(URL_PATTERN)

    if (!matched) {
      throw new TypeError('URLの形式が正しくありません: ' + this.url)
    }
    this.protocol = matched[1]
    this.domain = matched[2]
    this.path = matched[3] || ''
    this.query = matched[4] || ''
    this.hash = matched[5] || ''
  }

  get encodedPath(): string {
    return ChamomileUrl.encodeUri(this.path)
  }

  get encodedQuery(): string {
    return ChamomileUrl.encodeUri(this.query)
  }

  get encodedHash(): string {
    return ChamomileUrl.encodeUri(this.hash)
  }

  get encodedUrl(): string {
    return this.protocol + this.domain + this.encodedPath + this.encodedQuery + this.encodedHash
  }

  get decodedPath(): string {
    return ChamomileUrl.decodeUri(this.path)
  }

  get decodedQuery(): string {
    return ChamomileUrl.decodeUri(this.query)
  }

  get decodedHash(): string {
    return ChamomileUrl.decodeUri(this.hash)
  }

  get decodedUrl(): string {
    return ChamomileUrl.decodeUri(this.url)
  }

  get fileName(): string {
    const index = this.path.lastIndexOf('/')
    return (index >= 0) ? this.path.substring(index + 1) : this.path
  }

  get decodedFileName(): string {
    return ChamomileUrl.decodeUri(this.fileName)
  }

  get isSecure(): boolean {
    return this.protocol === 'https://'
  }

  static parse(url: string): ChamomileUrl | undefined {
    try {
      return new ChamomileUrl(url)
    } catch (error) {
      return undefined
    }
  }

  private static encodeUri(value: string): string {
    // % 以外をURLエンコード
    return value.split('%')
      .map(v => encodeURI(v))
      .join('%')
  }

  private static decodeUri(value: string): string {
    return decodeURI(value)
  }

  toSecureUrl(): ChamomileUrl {
    if (this.isSecure) {
      return this
    }
    return new ChamomileUrl('https://' + this.domain + this.path + this.query + this.hash)
  }

  toString(): string {
    return this.url
  }
}
